import { render, staticRenderFns } from "./EgrantySwitch.vue?vue&type=template&id=81be3da6&scoped=true&"
import script from "./EgrantySwitch.vue?vue&type=script&lang=js&"
export * from "./EgrantySwitch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81be3da6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VSubheader } from 'vuetify/lib'
import { VSwitch } from 'vuetify/lib'
installComponents(component, {VFlex,VLayout,VSubheader,VSwitch})
